import type { FC } from 'react';

import { SECTION_IDS } from '@/features/home/constants/home.constants';
import type { FeatureCard } from '@/types/home.types';

interface FeatureGridProps {
  features: FeatureCard[];
}

const FeatureGrid: FC<FeatureGridProps> = ({ features }) => (
  <section id={SECTION_IDS.features} className="scroll-mt-20 bg-[var(--color-surface-muted)]">
    <div className="mx-auto w-full max-w-6xl px-5 py-20 md:px-8">
      <header className="max-w-2xl">
        <h2 className="font-display text-3xl font-extrabold text-[var(--color-ink)] md:text-4xl">
          Everything the campus already shares, in one place
        </h2>
        <p className="mt-4 text-base leading-relaxed text-[var(--color-ink-muted)]">
          Shoutt turns the group-chat scramble for a charger, a tripod or a suit into something
          organised, priced and accountable.
        </p>
      </header>

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((feature) => (
          <article
            key={feature.title}
            className="flex flex-col gap-3 rounded-3xl border border-[var(--color-divider)] bg-white p-7 shadow-[var(--shadow-card)] transition-shadow hover:shadow-[var(--shadow-card-hover)]"
          >
            <span aria-hidden className="text-2xl">
              {feature.icon}
            </span>
            <h3 className="font-display text-lg font-bold text-[var(--color-ink)]">
              {feature.title}
            </h3>
            <p className="text-sm leading-relaxed text-[var(--color-ink-muted)]">{feature.body}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default FeatureGrid;
